import updateVodSettings from 'shared/redux/server/actions/vod-settings/update';

export default biHandlers => ({ getState, dispatch }) => next => action => {
  const previousState = getState();
  const returnValue = next(action); // eslint-disable-line callback-return
  const { type } = action;
  const handler = biHandlers[type];

  if (handler) {
    handler({
      state: getState(),
      previousState,
      action,
      updateVodSettings: data => updateVodSettings(data)(dispatch, getState),
    });
  }

  return returnValue;
};
